import gql from 'graphql-tag';
import STUDENT_SETTINGS_FRAGMENT from '../fragments/student-setting';

const GET_STUDENT_SETTINGS = gql`
  query getStudentSettings($where: StudentSettingsWhereInput!) {
    studentSettings(where: $where) {
      ...BaseStudentSettings
    }
  }
  ${STUDENT_SETTINGS_FRAGMENT}
`;

export default GET_STUDENT_SETTINGS;
